const RESOURCE_TYPES = {
  FETCH_RESOURCE_LIST_BEGIN: "FETCH_RESOURCE_LIST_BEGIN",
  FETCH_RESOURCE_LIST_SUCCESS: "FETCH_RESOURCE_LIST_SUCCESS",
  FETCH_RESOURCE_LIST_FAILURE: "FETCH_RESOURCE_LIST_FAILURE",

  FETCH_RESOURCE_DETAILS_BEGIN: "FETCH_RESOURCE_DETAILS_BEGIN",
  FETCH_RESOURCE_DETAILS_SUCCESS: "FETCH_RESOURCE_DETAILS_SUCCESS",
  FETCH_RESOURCE_DETAILS_FAILURE: "FETCH_RESOURCE_DETAILS_FAILURE",

  FETCH_SONGS_BEGIN: "FETCH_SONGS_BEGIN",
  FETCH_SONGS_SUCCESS: "FETCH_SONGS_SUCCESS",
  FETCH_SONGS_FAILURE: "FETCH_SONGS_FAILURE",
};

export default RESOURCE_TYPES;
